import { Component } from '@angular/core';
import { environment } from '../../../Environment/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
  currentYear: Date = new Date();
  AssetbasePath = environment.assetsPath;
}
